import { Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { GemstoneArrangementWithSetting } from 'src/app/interfaces/gemstone-arrangement-with-setting';

@Injectable({
  providedIn: 'root'
})
export class StoneArrangementsWithSettingsProviderService extends APIProviderService<GemstoneArrangementWithSetting> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Gemstones/ArrangementsWithSettings`;
  }
}
